export default __webpack_public_path__ + "static/media/sarvesh.60f00d41.jpeg";